import PropTypes from 'prop-types';

export const ArrowLeftIcon = ({ color }) => (
  <svg width="32" height="14" viewBox="0 0 32 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 7L21.2453 13.0622V0.937822L32 7Z" fill={color} />
    <rect y="6" width="22" height="2" fill={color} />
  </svg>
);

export const ArrowCircleIcon = ({ color }) => (
  <svg width="34" height="49" viewBox="0 0 34 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.99223 2.59936L0.0196212 5.19871L11.0495 14.8555L22.0794 24.5123L11.0397 34.1776L0 43.8423L3.00554 46.4215L6.01109 49L20.0052 36.7543L34 24.5086L19.9828 12.2543L5.96554 0L2.99223 2.59936Z" fill={color} />
  </svg>
);

ArrowCircleIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

ArrowLeftIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
